const secToMs = (secs: number): number => {
  return secs * 1000;
};

export default secToMs;
